import React, { FC } from 'react';

import { Box, IconButton, Tooltip } from '@mui/material';
import { FormikProps } from 'formik';

import PendingTabs from '../../PendingTabs';
import strings from '../../../../localization';

import AdminPharmacySearchFields from '../../../common/AdminPharmacySearchFields';
import SelectAllHeader from '../../../DynamicTable/SelectAllHeader';
import { PharmacyListTabTypes } from '../../../../helpers/Constants';
import assignAccountsIcon from '../../../../assets/svg/assignAccountsIcon.svg';
import useAdmin from '../../../../hooks/useAdmin';

import OwnershipStatusFilter from './OwnershipStatusFilter';
import { tabConfig } from './helper';

interface IPharmacyListHeader {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  formik: FormikProps<any>;
  setSelected: React.Dispatch<React.SetStateAction<PharmacyListTabTypes>>;
  selectedTab: PharmacyListTabTypes;
  handleReset: () => void;
  canBulkAssign: boolean;
  selectAll: boolean;
  handleSelectAll: (toBeSet: boolean) => void;
  bulkAssignOwner: () => void;
  hasSelection: boolean;
  isMyAccounts: boolean;
}

const PharmacyListHeader: FC<IPharmacyListHeader> = ({
  formik,
  selectedTab,
  setSelected,
  handleReset,
  canBulkAssign,
  selectAll,
  handleSelectAll,
  bulkAssignOwner,
  hasSelection,
  isMyAccounts,
}) => {
  const { isSuperAdmin } = useAdmin();

  const handleTabClick = (tab: PharmacyListTabTypes) => {
    setSelected(tab);
  };

  const { handleSubmit } = formik ?? {};

  return (
    <Box component="form" onSubmit={handleSubmit}>
      <PendingTabs
        selectedTab={selectedTab}
        tabConfig={tabConfig(handleTabClick)}
        header={strings.pharmaciesList}
      />
      <AdminPharmacySearchFields
        formik={formik}
        handleReset={handleReset}
        extraFilters={
          isSuperAdmin && !isMyAccounts ? (
            <OwnershipStatusFilter formik={formik} />
          ) : null
        }
      />
      {canBulkAssign && (
        <SelectAllHeader
          selectAll={selectAll}
          handleSelectAll={handleSelectAll}
          CustomIcon={(
            <Tooltip title={strings.assignOwnerToSelected}>
              <span>
                <IconButton onClick={bulkAssignOwner} disabled={!hasSelection}>
                  <img src={assignAccountsIcon} alt={strings.assignOwner} />
                </IconButton>
              </span>
            </Tooltip>
          )}
        />
      )}
    </Box>
  );
};

export default PharmacyListHeader;
